import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "taxRate"]

  connect() {
    this.updateDisplay()
  }

  updateDisplay() {
    const selectElement = this.selectTarget
    const taxTypeId = selectElement.value

    console.log("change", taxTypeId)

    if (taxTypeId) {
      fetch(`/tax_types/${taxTypeId}`)
        .then(response => response.json())
        .then(data => {
          this.taxRateTarget.value = data.tax_rate;
          this.taxRateTarget.dispatchEvent(new Event('change'))
        })
    }
  }

  change() {
    this.updateDisplay()
  }
}
